// @Todo need to correct type import
import type { Props as InputTextViewProps } from 'components/InputTypes/InputText/View';
import {
  EAccountFieldNumericBoolean,
  IAbstractAccountFieldEditForm,
  IAbstractAccountFieldParams,
  IAbstractAccountFiled
} from 'newcomponents/Shared/account/Fields/accountFields.type';

export enum EPersonalIdTypes {
  default = '0',
  pesel = '1',
  cpf = '2',
  rut = '3'
}

export interface IPersonalIdFiledEditForm
  extends IAbstractAccountFieldEditForm {
  checkByPayBrokerService: EAccountFieldNumericBoolean;
  showOnRegFields: EAccountFieldNumericBoolean;
  label: string;
  required: EAccountFieldNumericBoolean;
  disabled: EAccountFieldNumericBoolean;
  checkCPF?: EAccountFieldNumericBoolean;
  checkByCountryCPF: EAccountFieldNumericBoolean;
  customValidation: EAccountFieldNumericBoolean;
  customValidationCode: RegExp;
  sendCPFAsDocNumber: EAccountFieldNumericBoolean;
  personalIdType: EPersonalIdTypes;
  showOnWalletRegFields: EAccountFieldNumericBoolean;
  showOnEditProfile: EAccountFieldNumericBoolean;
  loginWithCPF: EAccountFieldNumericBoolean;
}

export interface IPersonalFieldParams extends IAbstractAccountFieldParams {
  validations: {
    required: boolean;
  };
}

export interface IPersonalIdFiled
  extends IAbstractAccountFiled<
    'personalId',
    IPersonalIdFiledEditForm,
    IPersonalFieldParams
  > {
  initialValue?: string;
}

export type TPersonalIdFieldProps = Omit<InputTextViewProps, 'field'> & {
  field: IPersonalIdFiled;
};
